import { http, HttpResponse } from "msw";

const RICKROLL_HLS = "https://www.youtube.com/watch?v=xvFZjo5PgG0";

/**
 * MediaMTX integration endpoints — what mtx's UI calls directly when
 * rendered as a federation remote inside uiv2.
 *
 * Note: /api/v1/product/proxy/mtx/** is covered by handlers/proxy.ts;
 * this file owns the direct mtx-specific paths.
 */
export const mtxHandlers = [
  http.get("/api/v1/mediamtx/streams", () => {
    return HttpResponse.json({
      streams: [
        {
          name: "fighter420",
          ready: true,
          viewers: 42,
          hls: RICKROLL_HLS,
        },
        {
          name: "drone-recon",
          ready: true,
          viewers: 7,
          hls: RICKROLL_HLS,
        },
      ],
    });
  }),

  // SRT defaults the UI reads to populate the connection details panel.
  http.get(
    "/api/v1/product/proxy/mtx/api/v1/proxy/srt_default",
    () => {
      return HttpResponse.json({
        port: 8890,
        host: "demo.dev.pvarki.fi",
        encryption: "passphrase",
        passphrase: "demo-passphrase",
      });
    },
  ),

  // Direct passthrough catch-all — keeps the UI from erroring on
  // endpoints we haven't explicitly fixtured yet.
  http.get("/api/v1/direct/*", () => {
    return HttpResponse.json({ demo: true, items: [] });
  }),

  http.get("/api/v1/proxy/*", () => {
    return HttpResponse.json({ demo: true, items: [] });
  }),
];
